export const environment = {
    production: false,
    apiUrl: 'https://performace-twin-api-stg.enacloud.me',
    apiUrlBuffer: '',

    client: '',
    redirectUri: 'https://gemminus-stg.enacloud.com.br',
    authority: '',
  };
